import React, { useEffect, useRef, useState } from "react";
import "./fulfilment.scss";
import { Iprops } from "./fullfilmentinterface";
import { RESOURCE } from "../../../const/resource";
import { useTranslation } from "react-i18next";
import FulfillmentSummary from "../FulfilmentAvailableSummary";
import OrderContact from "../Shipment/OrderContact";
import ShippingMethod from "../Shipment/ShippingMethod";
import ShippingInfo from "../Shipment/ShippingInfo";
import { ModalPopup } from "../../CommonComponent";
import Availabilityimg from "../../../assets/images/Drag.svg";
import { useSelector } from "react-redux";
import { selectors as headerSelector } from "../../../state/features/header";
import { ICartContextType } from "../../ShoppingCart/ShoppingCartPromo/shoppingcartpromointerface";
import { useCartContext } from "../../ShoppingCart/shoppingcart";
import NoImage from "../../../assets/images/NoImage.png";
import { AVAILABILITYTYPE } from "../../../const/enum";
import Loader from "../../Loader";
import { selectors as globalDataSelector } from "../../../state/features/common/globaldata";
import partsservice from "../../../services/partsservice";
import helperfunctions from "../../../utils/helperfunctions";

const Fulfilment = (props: Iprops) => {
    const { t } = useTranslation();
    const { shipping, pickupAvailablePlus, pickup, pickupWillCall_KomatsuShipping } = props?.fulfillmentDetailRes?.data ?? {};
    const { stepperDetails, cartsDetails, isStepOneLoading, isGuestUser }: ICartContextType = useCartContext();
    const initialDataList = { loading: false, data: [] };
    const [stateList, setStateList] = useState(initialDataList);
    const [countryList, setCountryList] = useState(initialDataList);
    const [options, setOptions] = useState<any>([]);
    const [shippingCarries, setShippingCarries] = useState<any>({ loading: false, data: {} });
    const defaultOption = { value: '', title: t(RESOURCE.MyK_Please_Select) };
    const fulfillment = stepperDetails?.fulfillment;
    const targetDivRef = useRef<any>(null);
    const scrollToDiv = () => {
        const yOffset = targetDivRef.current.offsetTop + 200;
        window.scrollTo({ top: yOffset, behavior: 'smooth' });
    };
    const [showShippingInfo, setShowShippingInfo] = useState<any>(false);
    const canShowShipping = pickupAvailablePlus?.shipping?.canShow;
    const canShowAdditionalPickup = pickupAvailablePlus?.additionalPickup?.canShow;
    const fulfillmentDiv = useRef<any>(null);
    const [selectedCarrier, setSelectedCarrier] = useState<any>({});
    const checkEstimatedCostDisabled = () => {
        let isDisabled =
            !(cartsDetails?.parts?.some((item: any) => {
                if (checkParts(item)) {
                    return true;
                }
                if ((item?.substituteParts?.some((s: any) => checkParts(s))) ?? false) {
                    return true;
                }
            }) ?? false)

        return isDisabled;
    }

    const checkParts = (part: any) => {
        return (!part?.isContactDealer && part?.isValidKomatsuProduct);
    };

    const [isEstimatedCostDisabled, setIsEstimatedCostDisabled] = useState<any>(false);

    useEffect(() => {
        setIsEstimatedCostDisabled(checkEstimatedCostDisabled());
    }, [])

    const {
        headercurrentuser,
        globalData
    }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state),
            globalData: globalDataSelector.globaldata(state)
        })
    );

    const updateSelectedCarrier = (carrier: any) => {
        setSelectedCarrier(carrier);
    };

    const isAvailabilityTypeFound = (availability :any) => {
        return availability?.some((t :any) =>
            (t.type?.toLowerCase() === AVAILABILITYTYPE[AVAILABILITYTYPE.ka] ||
                t.type?.toLowerCase() === AVAILABILITYTYPE[AVAILABILITYTYPE.da]) &&
            t.availabilityCount > 0 && !t.isContactDealer
        );
    };

    const checkIsOtherOrKomatsuBranch = () => {
        let isExists =  cartsDetails?.parts?.some((item :any) => {
            if (isAvailabilityTypeFound(item?.availability)) {
                return true; 
            }
            if ((item?.substituteParts?.some((s: any) => isAvailabilityTypeFound(s?.availability))) ?? false) {
                return true;
            }
        }) ?? false;

        return isExists;
    }

    const isAvailabilityOthenThenKomatsuFoundFulfillment = (availability: any) => {
        return (availability?.some((t: any) =>
            (t.type?.toLowerCase() === globalData?.BranchCode?.toLowerCase() ||
                t.type?.toLowerCase() === AVAILABILITYTYPE[AVAILABILITYTYPE.da]) &&
            t.availabilityCount > 0 && !t.isContactDealer
        ));
    };

    const checkIsNotOnlyKomatsuBranchFulfillment = () => {
        let isNotExists = cartsDetails?.parts?.some((item: any) => {
            if (isAvailabilityOthenThenKomatsuFoundFulfillment(item?.availability)) {
                return true;
            }
            if ((item?.substituteParts?.some((s: any) => isAvailabilityOthenThenKomatsuFoundFulfillment(s?.availability))) ?? false) {
                return true;
            }
        }) ?? false;

        return isNotExists;
    }

    const [isKomatsuOnly] = useState<any>(!checkIsNotOnlyKomatsuBranchFulfillment());

    const getCanShowPickupAvailablePlus = () => {
        return ((canShowShipping || canShowAdditionalPickup) ?? false);
    }
    useEffect(() => {
        if (fulfillmentDiv) {
            props?.getDivRef(fulfillmentDiv, 'fulfillmentDiv')
        }
    }, [fulfillmentDiv])

    const updateShippingInfo = (isShippingType: any, isPickupType: any) => {
        const errorObj = { ...stepperDetails?.shipment?.error };
        props?.updateShipmentDetails({ ...stepperDetails?.shipment, "isShippingType": isShippingType, "isPickupType":isPickupType, error: errorObj });
    }

    const setShippingInfoAndOrderContact = (fulfillment: any) => {
        if (fulfillment?.isPickup) {
            setShowShippingInfo(pickup?.showShippingInfo);
            updateShippingInfo(pickup?.showShippingInfo, pickup?.showOrderContact);
        }
        else if (fulfillment?.isPickupWillCallKomatsuShipping) {
            setShowShippingInfo(pickupWillCall_KomatsuShipping?.showShippingInfo);
            updateShippingInfo(pickupWillCall_KomatsuShipping?.showShippingInfo, pickupWillCall_KomatsuShipping?.showOrderContact);
        }
        else if (fulfillment?.isShipping) {
            setShowShippingInfo(shipping?.showShippingInfo);
            updateShippingInfo(shipping?.showShippingInfo, shipping?.showOrderContact);
        }
        else if (fulfillment?.isPickupAvailablePlusShipping) {
            setShowShippingInfo(pickupAvailablePlus?.shipping?.showShippingInfo);
            updateShippingInfo(pickupAvailablePlus?.shipping?.showShippingInfo, pickupAvailablePlus?.shipping?.showOrderContact);
        }
        else if (fulfillment?.isPickupAvailablePlusAdditionalPickup) {
            setShowShippingInfo(pickupAvailablePlus?.additionalPickup?.showShippingInfo);
            updateShippingInfo(pickupAvailablePlus?.additionalPickup ?.showShippingInfo, pickupAvailablePlus?.additionalPickup?.showOrderContact);
        }
    }

    useEffect(() => {
        if (fulfillment) {
            const optionData = [
                {
                    title: checkIsOtherOrKomatsuBranch() ? t(RESOURCE.MyK_Label_ShoppingCart_Pickup_WillCall) : t(RESOURCE.MyK_Label_ShoppingCart_Pickup),
                    description: t(RESOURCE.MyK_Label_ShoppingCart_Pickup_WillCall_Info),
                    activeClass: fulfillment?.isPickup ? 'active' : '',
                    onClick: props.onPickup,
                    canShow: pickup?.canShow ?? false
                },
                {
                    title: t(RESOURCE.MyK_Label_ShoppingCart_Pickup_KomatsuShipping),
                    description: t(RESOURCE.MyK_Label_ShoppingCart_Pickup_KomatsuShipping_info),
                    activeClass: fulfillment?.isPickupWillCallKomatsuShipping ? 'active' : '',
                    onClick: props.onPickupWillCallKomatsuShipping,
                    canShow: pickupWillCall_KomatsuShipping?.canShow ?? false
                },
                {
                    title: t(RESOURCE.MyK_Label_ShoppingCart_Pickup_AvailablePlus),
                    description: t(RESOURCE.MyK_Label_ShoppingCart_Pickup_AvailablePlus_Info),
                    activeClass: fulfillment?.isPickupAvailable ? 'active' : '',
                    onClick: props.onPickupAvailable,
                    canShow: getCanShowPickupAvailablePlus()
                },
                {
                    title: t(RESOURCE.MyK_Label_ShoppingCart_DropShip_Fulfillment_Shipping_Tab),
                    description: t(RESOURCE.MyK_Label_ShoppingCart_ShippingOption_Info),
                    activeClass: fulfillment?.isShipping ? 'active' : '',
                    onClick: props.onShipping,
                    canShow: shipping?.canShow ?? false
                }
            ];
            setOptions(optionData);  
        }

        setShippingInfoAndOrderContact(fulfillment);
    }, [fulfillment])


    const branchData = props?.fullfilmentBranchInfo?.data;
    const { imgBaseUrlSelectors }: any = useSelector((state) => ({
        imgBaseUrlSelectors: headerSelector.imgbaseUrl(state),
    }));

    const getFullAddress = () => {
        let fullAddress = '';
        const address1 = branchData?.address1?.trim();
        const address2 = branchData?.address2?.trim();
        const address3 = branchData?.address3?.trim();
        const city = branchData?.city?.trim();
        const stateName = branchData?.stateName?.trim();
        const countryName = branchData?.countryName?.trim();
        const postalCode = branchData?.postalCode?.trim();
        if (address1) {
            fullAddress += `${address1}, `;
        }
        if (address2) {
            fullAddress += `${address2}, `;
        }
        if (address3) {
            fullAddress += `${address3}, `;
        }
        if (city) {
            fullAddress += `${city}, `;
        }
        if (stateName) {
            fullAddress += `${stateName}, `;
        }
        if (countryName) {
            fullAddress += `${countryName}, `;
        }
        if (postalCode) {
            fullAddress += `${postalCode}`;
        }

        return fullAddress;
    }

    const getEmptyValueWhenNull = (value: any) => {
        return value ?? "";
    }

    const getShippingCarriers = async (shippingMethodId: any, shipmentObj: any) => {
        if (shippingMethodId) {
            const reqBody = {
                cartId: cartsDetails?.cart?.cartId ?? 0,
                customerId: getEmptyValueWhenNull(globalData?.CustomerId),
                shippingMethodCode: shippingMethodId,
                userAadId: getEmptyValueWhenNull(headercurrentuser?.azureADId),
                shipToAddressId: stepperDetails?.shipment?.addressId ?? 0,
                excludePickupItems: false,
                partNumbers: "",
                shipToAddress: {
                    "addressType": stepperDetails?.shipment?.addressType,
                    "firstName": stepperDetails?.shipment?.firstName,
                    "lastName": stepperDetails?.shipment?.lastName,
                    "companyName": stepperDetails?.shipment?.companyName || (isGuestUser ? stepperDetails?.shipment?.firstName : globalData?.CustomerName),
                    "companyId": stepperDetails?.shipment?.customerId,
                    "address1": stepperDetails?.shipment?.address1,
                    "address2": stepperDetails?.shipment?.address2,
                    "countryCode": stepperDetails?.shipment?.countryCode,
                    "stateCode": stepperDetails?.shipment?.stateCode,
                    "city": stepperDetails?.shipment?.city,
                    "postalCode": stepperDetails?.shipment?.postalCode,
                    "addressId": stepperDetails?.shipment?.addressId,
                    "phone": stepperDetails?.shipment?.phone,
                    "phoneCountryCode": stepperDetails?.shipment?.phoneCountryCode,
                    "attention": stepperDetails?.shipment?.attention
                }
            }
            await getShippingCarrierList(shipmentObj, reqBody);
        }  
    };

    const checkCarrierCondition = (response: any) => {
        return (response?.data?.komatsucharges?.amount > 0 && response?.data?.carriers?.length <= 0);
    }

    const getShippingCarrierList = async (shipmentObj: any, reqBody:any) => {
        try {
            if (!shipmentObj) {
                shipmentObj = { ...stepperDetails?.shipment };
            }
            updateShipmentData("", "", shipmentObj);
            setShippingCarries({ loading: true, data: {} });
            const response = await partsservice.getShippingCarriers(reqBody);
            if (checkCarrierCondition(response)) {
                response.data.errors = [];
                const model = {
                    cartId: cartsDetails?.cart?.cartId,
                    shippingCost: response?.data?.komatsucharges?.amount ?? 0,
                };
                partsservice.calculateShippingCost(model)
                    .then((response: any) => {
                        props.getItemSummaryDetailsWithoutLoading();
                    })
                    .catch((e: any) => {
                    });
            }
            const carriers = Array.isArray(response?.data?.carriers) && response?.data?.carriers.length > 0 ? [defaultOption, ...response.data.carriers ?? []] : [];
            if (response?.isSuccess) {
                const selectedCarrier = carriers?.find((s: any) => s.isSelected);
                updateShipmentData(selectedCarrier?.id, selectedCarrier?.carrierCode, shipmentObj);
                updateSelectedCarrier(selectedCarrier?.id ? selectedCarrier : defaultOption);
                setShippingCarries({ loading: false, data: { ...response?.data, carriers: carriers?.map((t: any) => ({ title: t.carrierName, value: t.id +'|'+ t.carrierCode, ...t })) ?? [] } });
            }
            else {
                setShippingCarries({
                    loading: false, data: {}
                });
                if (response?.msg === 'Failed') {
                    helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Shipping_Carrier_Failed));
                } else {
                    helperfunctions.showErrorMessage(`${response?.msg}`);
                }
            }
        } catch (error) {
            setShippingCarries({
                loading: false, data: {}
            });
            helperfunctions.showErrorMessage(`${error}`);
        }
    }

    const updateShipmentData = (serviceTypeId: any, carrierCode: any,  shipmentObj: any = {}) => {
        const errorObj = { ...stepperDetails?.shipment?.error, serviceTypeId : false };
        props?.updateShipmentDetails({ ...stepperDetails?.shipment, ...shipmentObj, serviceTypeId: serviceTypeId, carrierCode: carrierCode, isShippingType: showShippingInfo, error: errorObj });
    }


    return (
        <div className="firstlevel_wrapper">
            <div>
                <p className="heading">{t(RESOURCE.MyK_Label_SC_Your_Ordering_Branch)}</p>
            </div>
            <div className="row">
                <div className="col-12 col-lg-6 col-xl-5 mb-sm-0 mb-md-3 mb-3">
                    <div className="tabs_wrapper">
                        <div className="distributorimg">
                            {branchData?.imagePath && <img src={branchData?.imagePath ?? ''} onError={(e: any) => { e.currentTarget.src = imgBaseUrlSelectors + NoImage }} alt="img" />}
                        </div>
                        <div className="distributor_right">
                            <p className="distributorname">{branchData?.distributorDisplayName}</p>
                            <p>{getFullAddress()}</p>
                            <span>{t(RESOURCE.Myk_Label_Phone)}:<span className="ml-2">{branchData?.phone ?? '-'}</span></span>
                            <div><span>{t(RESOURCE.Myk_Label_Fax)}:</span><span className="ml-2">{branchData?.fax ?? '-'}</span></div>
                        </div>
                    </div>
                </div>
                {!isGuestUser && <div className="col-12 col-lg-6 col-xl-5 mb-sm-0 mb-md-3 mb-3">
                    <div className="tabs_wrapper availability" onClick={props.onAvailablityPopup} onKeyDown={() => { }}>
                        <div>
                            <div>
                                <p className="Availability_Summary mb-2">{t(RESOURCE.MyK_Label_SC_Availability_Summary)}</p>
                            </div>
                            <div>
                                <p className="mb-4">{t(RESOURCE.MyK_Label_SC_Fulfilment_Availability_Summary_Info)}</p>
                            </div>
                        </div>
                        <div className="avaialbleimg_wrapper mx-3"><img src={Availabilityimg} /></div>
                    </div>
                </div>}
            </div>

            {(props?.fullfilmentBranchInfo?.loading || isStepOneLoading || props?.weatherWarning?.loading || props?.savedAddressList?.loading || stateList?.loading || countryList?.loading) && <Loader />}
                <div>
                    <div className="my-1">
                        <p className="heading">{t(RESOURCE.MyK_Label_SC_Select_One)}</p>
                    </div>
                    <div className="row">
                        {options?.filter((s: any) => s.canShow)?.map((option :any) => (
                            <div className="col-12 col-lg-4 col-xl-4 mb-sm-0 mb-md-2 mb-2" key={option.title}>
                                <div className={`closedcard pickup ${option.activeClass}`} onClick={option.onClick} onKeyDown={() => { }}>
                                    <div className="pickup_title">{option.title}</div>
                                    <div className="mt-3 closedcard_content">{option.description}</div>
                                    <input type="radio" className="shipping_Select" name="selectshipment" onChange={() => { } } checked={option.activeClass == 'active'} />
                                </div>
                            </div>
                        ))}
                    </div>

                {(fulfillment?.isPickup || fulfillment?.isPickupAvailable || fulfillment?.isPickupWillCallKomatsuShipping) &&
                        <div className="alert information mb-3">
                        {fulfillment?.isPickupAvailable && <span><span className="fa fa-check-circle"></span>{t(RESOURCE.Myk_Info_SC_FAS_OrderingBranch_Info)}<a className="avaiabilitylink" onClick={props.onAvailablityPopup} onKeyDown={() => { }}>{t(RESOURCE.MyK_Label_SC_Availability_Summary)}</a></span>}
                        {fulfillment?.isPickup && <span><span className="fa fa-check-circle"></span>{t(RESOURCE.Myk_Info_SC_FAS_OrderingBranch_Info_Pickup)}</span>}   
                        {fulfillment?.isPickupWillCallKomatsuShipping && <span><span className="fa fa-check-circle"></span>{t(RESOURCE.Myk_Info_SC_FAS_OrderingBranch_Info_Pickup_KomatsuShipping)}</span>}
                        </div>
                    }

                    {fulfillment?.isPickup &&
                        <div>
                            <OrderContact isNextClick={props?.isNextClick} shipmentDetails={props?.shipmentDetails} updateShipmentDetails={props?.updateShipmentDetails} phoneCodeOption={props?.phoneCodeOption} />
                        </div>
                    }

                    <div className="shippingmethod_wrapper">
                        {fulfillment?.isPickupAvailable &&
                            <div>
                                <div>
                                    <div className="row">
                                        <div className="mb-2"><span className="selectedtabs_subheading">
                                            <span className="pointerView"></span>{t(RESOURCE.Myk_Info_SC_FulFill_Remainder)}</span>
                                        </div>
                                    </div>
                                    <div className="shippingcard shippingcard_Radio">
                                        <div className={canShowShipping ? "row mb-2" : 'd-none'} >
                                            <div className="col-2 col-md-2 col-lg-1 col-xl-1">
                                                <input type="radio" className="select_radiobutton" name="fulfill_remainder" id="shipping" checked={fulfillment?.isPickupAvailablePlusShipping} onChange={props.onPickupAvailablePlusShipping} /></div>
                                            <div className="col-10 col-md-10 col-lg-11 col-xl-11 selectpickup pl-0"><div><span className="selectpickup_label">{t(RESOURCE.MyK_Label_SC_Shipping)}</span></div><div><span>{t(RESOURCE.MyK_Label_ShoppingCart_Pickup_AvailablePlus_ShippingInfo)}</span>
                                            </div>
                                            </div>
                                        </div>
                                        <div className={canShowAdditionalPickup ? "row mb-3" : 'd-none'}>
                                            <div className="col-2 col-md-2 col-lg-1 col-xl-1">
                                                <input type="radio" className="select_radiobutton" name="fulfill_remainder" id="additionalPickup" checked={fulfillment?.isPickupAvailablePlusAdditionalPickup} onChange={props.onPickupAvailablePlusAdditionalPickup} /></div>
                                            <div className="col-10 col-md-10 col-lg-11 col-xl-11 selectpickup pl-0"><div>
                                                <span className="selectpickup_label">{t(RESOURCE.MyK_Label_SC_Fulfillment_Additional_Pickup_WillCall)}</span></div><div><span>{t(RESOURCE.MyK_Label_ShoppingCart_DropShip_Fulfillment_Additional_Pickup_Info)}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                </div>

                {((fulfillment?.isPickupAvailable && fulfillment?.isPickupAvailablePlusAdditionalPickup) || fulfillment?.isPickupWillCallKomatsuShipping) &&
                         <>
                            {!fulfillment?.isPickupWillCallKomatsuShipping && <div className="alert information mt-3 mb-4">
                                <span><span className="fa fa-check-circle"></span>{t(RESOURCE.Myk_Info_SC_FAS_OrderingBranch_Info_Pickup)}</span>
                            </div>}
                            <div className="mb-3">
                                 <OrderContact isNextClick={props?.isNextClick} shipmentDetails={props?.shipmentDetails} updateShipmentDetails={props?.updateShipmentDetails} phoneCodeOption={props?.phoneCodeOption} />
                             </div>
                         </>
                }

                {((fulfillment?.isPickupAvailable && (fulfillment?.isPickupAvailablePlusShipping || (fulfillment?.isPickupAvailablePlusAdditionalPickup && showShippingInfo))) || fulfillment?.isShipping || fulfillment?.isPickupWillCallKomatsuShipping) &&
                        <>
                           {fulfillment?.isPickupAvailablePlusShipping &&
                                        <>
                                            <div className="shippingmethod_wrapper">
                                                <div className="my-1 mt-3">
                                                    <p className="heading">{t(RESOURCE.Myk_Info_SC_Select_Shipping)}</p>
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <OrderContact isNextClick={props?.isNextClick} shipmentDetails={props?.shipmentDetails} updateShipmentDetails={props?.updateShipmentDetails} phoneCodeOption={props?.phoneCodeOption} />
                                            </div>
                                        </>
                    }

                            <div className="shippingmethod_wrapper">
                                <div className="mb-3">
                                    <ShippingInfo
                                        getWeatherWarning={props?.getWeatherWarning}
                                        savedAddressList={props?.savedAddressList}
                                        weatherWarning={props?.weatherWarning}
                                        savedAddressOptions={props?.savedAddressOptions}
                                        getDivRef={props?.getDivRef}
                                        phoneCodeOption={props?.phoneCodeOption}
                                        updateShipmentDetails={props?.updateShipmentDetails}
                                        setCountryList={setCountryList}
                                        setStateList={setStateList}
                                        stateList={stateList}
                                        countryList={countryList}
                                        isNextClick={props?.isNextClick}
                                        baseRef={props?.baseRef}
                                        updateSelectedCarrier={updateSelectedCarrier}
                                        selectedCarrier={selectedCarrier}
                                        getShippingCarriers={getShippingCarriers}
                                    />
                                </div>
                        <div className="mb-3">
                            <ShippingMethod isKomatsuOnly={isKomatsuOnly} updateSelectedCarrier={updateSelectedCarrier}
                                setShippingCarries={setShippingCarries}
                                isEstimatedCostDisabled={isEstimatedCostDisabled}
                                selectedCarrier={selectedCarrier} shippingCarries={shippingCarries} updateShipmentData={updateShipmentData} getShippingCarriers={getShippingCarriers} isNextClick={props?.isNextClick} getItemSummaryDetailsWithoutLoading={props?.getItemSummaryDetailsWithoutLoading} getDivRef={props?.getDivRef} shipmentDetails={props.shipmentDetails} updateShipmentDetails={props?.updateShipmentDetails} setIsServiceTypeRequired={props?.setIsServiceTypeRequired} />
                                </div>
                            </div>
                        </>
                    }
                </div>
            
            {props.isAvailabilityPopup &&
                <ModalPopup
                    ModalPopupTitle={t(RESOURCE.MyK_Label_SC_Availability_Summary)}
                    ModalPopupType="large"
                    closeModalPopup={props.onAvailablityPopup}>
                    <FulfillmentSummary shoppingcartOnClick={props?.shoppingcartOnClick} availabilityDetails={props?.availabilityDetails} scrollToDiv={scrollToDiv} />
                </ModalPopup>
            }
        </div>
    );
};

export default Fulfilment;
